import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getJSON } from "@/lib/api";
import { store } from "@/lib/store";
import { translate } from "@/lib/i18n";
import { warn } from "@/lib/log";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [emergency, setEmergency] = useState({ active: false });
  const [nation, setNation] = useState(store.getNation());
  const [lite, setLite] = useState(false);
  const [lang, setLang] = useState(store.getLang());

  const refreshEmergency = useCallback(async () => {
    try { setEmergency(await getJSON("/emergency-mode")); } catch (e) { warn("Emergency status check failed; keeping last known banner", e); }
  }, []);

  useEffect(() => { refreshEmergency(); const t = setInterval(refreshEmergency, 60000); return () => clearInterval(t); }, [refreshEmergency]);

  useEffect(() => {
    document.body.classList.toggle("emergency-mode", !!emergency.active && !emergency.auto);
  }, [emergency.active, emergency.auto]);

  useEffect(() => {
    document.body.classList.toggle("lite-mode", lite);
  }, [lite]);

  useEffect(() => {
    document.documentElement.lang = lang === "cy" ? "cy" : "en";
  }, [lang]);

  const changeNation = (n) => { setNation(n); store.saveNation(n); };
  const changeLang = (l) => { setLang(l); store.saveLang(l); };
  const t = useCallback((key) => translate(lang, key), [lang]);

  return (
    <AppContext.Provider value={{ emergency, refreshEmergency, nation, changeNation, lite, setLite, lang, changeLang, t }}>
      {children}
    </AppContext.Provider>
  );
}
